<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-alert dense border="left" class="text-center" color="primary" dark>
          <!-- <h3>INFORMACIÓN DEL {{ $t("titulo.colegioArticulo") }}</h3> -->
          <h3>INFORMACIÓN DEL ESTUDIANTE</h3>
        </v-alert>
      </v-col>
    </v-row>

    <!-- <template v-if="$vuetify.breakpoint.mdAndUp">
      </template> -->
    <v-row dense>
      <v-col cols="12" md="2">
        <AutocompleteComp v-model="filter.id_nivel" :items="listNivel" item-value="id" item-text="desc_nivel"
          @change="EventNivel(filter.id_nivel)" textLabel="Nivel" />
      </v-col>

      <v-col cols="12" md="2">
        <AutocompleteComp textLabel="Periodo" v-model="filter.id_periodo" @change="EventPeriodo(filter)"
          :items="listPeriodo" item-value="id" item-text="nombre_periodo" />
      </v-col>

      <v-col cols="12" md="2">
        <AutocompleteComp textLabel="Grado" v-model="filter.id_grado" @change="EventGrado(filter.id_grado)"
          :items="listGrado" item-value="id" item-text="desc_grado" />
      </v-col>

      <v-col cols="12" md="2">
        <AutocompleteComp textLabel="Sección" v-model="filter.id_seccion" @change="EventSeccion()" :items="listSeccion"
          item-value="id" item-text="nombre_seccion" />
      </v-col>

      <v-col cols="12" md="4">
        <AutocompleteComp textLabel="Estudiante" v-model="filter.id_alumno" :items="listAlumno" item-value="id"
          item-text="nombre_apellido" @change="listarLibretaNotas" />
      </v-col>
    </v-row>

    <v-treeview :items="treeData" ref:close :open="openNodes" rounded hoverable activatable open-on-click transition>
      <template v-slot:label="{ item }">
        <v-icon> {{ !item.customNode ? "mdi-folder" : "" }} </v-icon>

        <template v-if="item.customNode == 'Datos'">
          <DatosPersonalesComp :ElEstudiante="ElEstudiante" :Nacionalidades="Nacionalidades" :listDocReq="listDocReq"
            :servidor="base_url" :GetPostulantes="GetPostulantes"></DatosPersonalesComp>
        </template>

        <!-- <template v-if="item.customNode == 'Admisión'">
          <h1>haajahjahahha</h1>
        </template> -->

        <template>
          <template v-if="item.customNode == 'Familiares'">
            <MisFamiliaresComp :Familiares="Familiares" :Error="error" :Nacionalidades="Nacionalidades">
            </MisFamiliaresComp>
            <!-- <v-pagination v-model="paginaActual" :length="totalPaginas" :disabled="isLoading" class="my-4">{{ paginaActual }}</v-pagination> -->
          </template>
        </template>


        <template v-if="item.customNode == 'Cursos'">
          <MisCursos :Cursos="dataAreasEval" :ElEstudiante="ElEstudiante" :selectedAlumno="filter.id_alumno"
            @alumnoSeleccionado="handleAlumnoSeleccionado"></MisCursos>
        </template>

        <template v-if="item.customNode == 'Evaluaciones'">
          <MisEvaluaciones :filter="filter" :data="data" @updateMisEvaluaciones="emitMisEvaluaciones">
          </MisEvaluaciones>
        </template>

        <!-- <template v-if="item.customNode == 'Simuladores'">
            <h5>Simuladores</h5>
          </template> -->

        <template v-if="item.customNode == 'Libretas'">
          <LibretaDelEstudiante :dataAreasEval="dataAreasEval" :listPeriodo="listPeriodo"></LibretaDelEstudiante>
          <!-- <PieChart /> -->
        </template>

        <template v-else>
          {{ item.name }}
        </template>
      </template>
    </v-treeview>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import { mapMutations } from "vuex";

// import PieChart from '../../components/ComponentsEst/Pie.vue'
import axios, { API_URL } from "@/helpers/axios";
import DatosPersonalesComp from "./Components/DatosPersonales.vue";
import MisCursos from "./Components/MisCursos.vue";
import MisEvaluaciones from "./Components/MisEvaluaciones.vue";
import LibretaDelEstudiante from "./Components/LibretaDelEstudiante.vue";

import MisFamiliaresComp from "./Components/MisFamiliares.vue";
// import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';

export default {
  name: "carpeta_estudiante",
  components: {
    // PieChart,
    AutocompleteComp,
    DatosPersonalesComp,
    MisFamiliaresComp,
    MisCursos,
    MisEvaluaciones,
    LibretaDelEstudiante,
  },
  data: () => ({
    treeData: [
      {
        name: "Carpeta del estudiante",
        children: [
          {
            name: "Datos personales",
            children: [
              {
                customNode: "Datos",
              },
            ],
          },
          // {
          //   name: "Mis documentos de admisión",
          //   children: [
          //     {
          //       customNode: "Admisión",
          //     },
          //   ],
          // },
          {
            name: "Mis familiares",
            children: [
              {
                customNode: "Familiares",
              },
            ],
          },
          {
            name: "Mis cursos",
            children: [
              {
                customNode: "Cursos",
              },
            ],
          },
          {
            name: "Mis evaluaciones",
            children: [
              {
                customNode: "Evaluaciones",
              },
            ],
          },

          {
            name: "Libreta de notas",
            children: [
              {
                customNode: "Libretas",
              },
            ],
          },
        ],
      },
    ],

    openNodes: [],
    filter: {},
    listPeriodo: [],
    listAlumno: [],
    listNivel: [],
    listGrado: [],
    listSeccion: [],
    ElDocente: [],
    ElEstudiante: [],
    Familiares: [],
    Nacionalidades: [],
    dataAreasCom: [],
    dataAreasEval: [],
    dataConducta: [],
    listDocReq: [],
    //PROPIEDAD DEL COMPONENTE TABULADOR
    tabValor: null,
    detallePerfil: "",
    error: "",
    datoLogin: sessionStorage,
    base_url: `${API_URL}`,
    data: [],
    paginaActual: 1,
    totalPaginas: 0,
    isLoading: false,
  }),

  watch: {
    paginaActual() {
      this.GetFamiliares();
    }
  },

  methods: {
    //datos personales comp
    getDocumentosRequeridos() {
      this.listDocReq = JSON.parse(this.postulante.doc_adjuntos);
      console.log(this.listDocReq);
    },

    async GetPostulantes() {
      try {

        this.listDocReq = [];
        let query = `?jstdocs=${true}&numdoc_postulante=${this.ElEstudiante.numdoc_persona}&id_colegio=${this.filter.id_colegio}`;
        let response = await axios.get(
          `/admision/postulante/${this.filter.id_colegio}/${query}`
        );
        console.log("GET POSTULANTES CARPETA", response);
        if (typeof response.data[0] == "object") this.listDocReq = JSON.parse(response.data[0].doc_adjuntos);
        // this.formatearFechas();
        if (response.data == null || response.data == "") {

          // this.consultaActiva = false;
        } else {
          // this.consultaActiva = true;
        }
      } catch (e) {
        console.error(e);
      }
    },

    close() {

    },
    handleAlumnoSeleccionado(selectedAlumno) {
      this.filter.id_alumno = selectedAlumno;
    },
    async LoadMain() {
      this.LimpiarFiltros();
      this.GetNivel(
        null,
        this.datoLogin.id_colegio,
        this.datoLogin.id_ano_lectivo
      );
    },

    LimpiarFiltros() {
      this.filter = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_alumno: "",
        id_periodo: "",
        id_nivel: "",
        id_grado: "",
        id_seccion: "",
        id_usuario: this.datoLogin.id,
      };
    },

    emitMisEvaluaciones() {
      // console.log('Función del componente padre activada desde el hijo');
      this.getEvaluacionAlumno(this.filter)
    },

    async GetNivel(id_periodo) {
      // this.GetPeriodo(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo);
      let params = {
        id_periodo,
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
          filter: params,
        });

        this.listNivel = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetGrado(id_colegio, id_nivel) {
      let params = { id_colegio, id_nivel };
      try {
        let response = await axios.post(`/sistema/integral/getGradoAdm/`, {
          filter: params,
        });
        this.listGrado = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetSeccion(id_colegio, id_grado) {
      let params = { id_colegio, id_grado };
      try {
        let response = await axios.post(`/sistema/integral/getSeccionAdm/`, {
          filter: params,
        });
        this.listSeccion = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // CAPACITACION DE CONVENTIONAL COMMITS
    async GetAlumnos() {
      let params = {
        id_ano_lectivo: this.filter.id_ano_lectivo,
        id_colegio: this.filter.id_colegio,
        id_seccion: this.filter.id_seccion,
      };
      let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, {
        filter: params,
      });
      this.listAlumno = [
        ...response.data.result,
        // { id: 0, nombre_apellido: "Todos" },
      ];
      // console.log("AlumnoSeccion", this.listAlumno);

    },

    async getEvaluacionAlumno(filter) {
      try {
        let response = await axios.post(`/evaluacion/alumnos/view/`, {
          filter,
        });
        this.data = response.data;
        // console.log(
        //   "LA DATA QUE SE RELLENA EN THIS.DATA OSEA ACA DEBE ESTAR LA RESPUESTA"
        // );
        console.log(this.data, "hjcjy");
        this.GetPostulantes()
        if (this.data.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No se encontrarón registros`,
            tiempo: null,
          });
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: error, tiempo: null });
      }
    },

    async GetPeriodo(id_nivel, id_colegio, id_ano_lectivo) {
      let params = { id_colegio, id_ano_lectivo };
      try {
        let response = await axios.post(`/sistema/integral/getPeriodo/`, {
          filter: params,
        });

        this.listPeriodo = response.data.filter(
          (objeto) => objeto.id_adm_nivel === id_nivel
        );

        // console.log(this.listPeriodo);
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async listarLibretaNotas() {
      const me = this;

      try {
        const response = await axios.post(
          `evaluacion/reporte/listarLibretaDeNotas/`,
          { filter: this.filter }
        );
        me.dataAreasCom = response.data.DATA_AREA_COMPETENCIA;
        me.dataAreasEval = response.data.DATA_AREA_NOTA;
        me.dataConducta = response.data.DATA_CONDUCTA;
        me.ElEstudiante = response.data.DATA_HEADER;

        this.GetFamiliares();
        this.getEvaluacionAlumno(this.filter)

      } catch (error) {
        console.error(error);
      }
    },

    async GetFamiliares() {

      this.isLoading = true;

      try {
        let url = "";

        if (this.filter.id_alumno !== 0) {
          url = `administrativo/familia/familiar/${this.filter.id_alumno}`;
        } else {
          url = `administrativo/familia/allfamiliares/${this.filter.id_colegio}?pagina=${this.paginaActual}`;
        }

        let response = await axios.get(url);

        if (response.data.familiares.length !== 0) {
          this.Familiares = response.data.familiares;
          this.Nacionalidades = response.data.nacionalidades;
          this.error = '';
          this.totalPaginas = response.data.totalPaginas;
          this.paginaActual = response.data.paginaActual || 1;
          // window.scrollTo({
          //   top: 0, // e.g., 0 to scroll to the top
          //   // behavior: "smooth"  // optional smooth scrolling
          // });
        } else {
          this.error = "El estudiante seleccionado no tiene un familiar asociado";
          this.$toast.warning('El estudiante seleccionado no tiene un familiar asociado');
          this.Familiares = [];
        }
      } catch (error) {
        console.log("Hubo un error al obtener familiares:", error);
      } finally {
        this.isLoading = false;
      }
    },


    EventNivel(id_nivel) {
      this.filter.id_grado = "";
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      this.listSeccion = [];
      this.listGrado = [];
      this.listAlumno = [];
      this.ElEstudiante = {};
      this.listDocReq = [];

      this.GetPeriodo(
        id_nivel,
        this.datoLogin.id_colegio,
        this.datoLogin.id_ano_lectivo
      );
    },

    EventPeriodo(items) {
      // this.listNivel = [];
      this.listGrado = [];
      this.listSeccion = [];
      this.listAlumno = [];
      this.ElEstudiante = {};
      this.listDocReq = [];

      // this.filter.id_nivel = "";
      this.filter.id_grado = "";
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      // this.GetNivel(id_periodo);
      this.GetGrado(this.datoLogin.id_colegio, items.id_nivel);
    },

    EventGrado(id_grado) {
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      this.listSeccion = [];
      this.listAlumno = [];
      this.ElEstudiante = {};
      this.listDocReq = [];

      this.GetSeccion(this.filter.id_colegio, id_grado);
    },

    EventSeccion() {
      this.filter.id_alumno = "";
      this.listAlumno = [];
      this.ElEstudiante = {};
      this.GetAlumnos();
      this.listDocReq = [];
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////
  },
  mounted() {
    this.LoadMain();
  },
  computed: {},
};
</script>
<style scoped>
i.v-icon.notranslate.material-icons.theme--light {
  display: none;
}

.v-treeview .v-treeview-node__level {
  width: 10px;
}
</style>
